import { render, staticRenderFns } from "./CreateForm.vue?vue&type=template&id=09f066a8&scoped=true&"
import script from "./CreateForm.vue?vue&type=script&lang=js&"
export * from "./CreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f066a8",
  null
  
)

export default component.exports